import { render, staticRenderFns } from "./ImageTextNavPreview.vue?vue&type=template&id=0835bca8&scoped=true"
import script from "./ImageTextNavPreview.vue?vue&type=script&lang=js"
export * from "./ImageTextNavPreview.vue?vue&type=script&lang=js"
import style0 from "./ImageTextNavPreview.vue?vue&type=style&index=0&id=0835bca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835bca8",
  null
  
)

export default component.exports